import { BadgeColor } from "sprint-common-web";

import { OnPremOrderSource } from "../../../../common/api/orders-api/on-prem-order/GetOnPremOrderListResponse";

export const resolveOnPremOrderSourceBadgeColor = (source: OnPremOrderSource): BadgeColor => {
    switch (source) {
        case OnPremOrderSource.Shreq:
            return BadgeColor.LightGreen;
        case OnPremOrderSource.Buzz:
            return BadgeColor.LightBlue;

        default:
            return BadgeColor.LightBlue;
    }
};
